import { useMemo } from 'react';

import { useMarketNavigator } from './useMarketNavigator';
import { useGoodsNavigator } from './useGoodsNavigator';
import { useCommonNavigator } from './useCommonNavigator';
import { useReviewsNavigator } from './useReviewsNavigator';
import { useScreensNavigator } from './useScreensNavigator';
import { moveToRoot } from './useCommonNavigator/moveToRoot';

export const useNavigator = () => {
  const { moveToMarketHome } = useMarketNavigator();
  const {
    moveToGoods,
    moveToGoodsList,
    moveToRecentlyViewedGoods,
    moveToRankingGoods,
  } = useGoodsNavigator();
  const {
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
    moveToLikeMarketList,
    moveToEditGoodsLike,
    moveToCategoryTab,
    moveToCategory,
    moveToSetting,
    moveToNotification,
  } = useCommonNavigator();
  const { moveToPhotoReviewList, moveToReviewList } = useReviewsNavigator();
  const { moveToFragmentScreens } = useScreensNavigator();

  const navigator = useMemo(
    () => ({
      moveToRoot,
      moveToWebview,
      moveToHome,
      moveToRecentlyViewedGoods,
      moveToMarketHome,
      moveToRankingGoods,
      moveToGoods,
      moveToGoodsList,
      moveToSearch,
      moveToToday,
      moveToLikeFolders,
      moveToLikeMarketList,
      moveToEditGoodsLike,
      moveToScreens,
      moveToSetting,
      moveToNotification,
      moveToPhotoReviewList,
      moveToReviewList,
      moveToFragmentScreens,
      moveToCategoryTab,
      moveToCategory,
    }),
    [
      moveToSetting,
      moveToNotification,
      moveToWebview,
      moveToHome,
      moveToRecentlyViewedGoods,
      moveToMarketHome,
      moveToRankingGoods,
      moveToGoods,
      moveToGoodsList,
      moveToSearch,
      moveToToday,
      moveToLikeFolders,
      moveToLikeMarketList,
      moveToEditGoodsLike,
      moveToScreens,
      moveToPhotoReviewList,
      moveToReviewList,
      moveToFragmentScreens,
      moveToCategoryTab,
      moveToCategory,
    ],
  );

  return { navigator };
};
